import { MedicalRecordRequest } from "../../api/medical-record-requests.type";
import { MedicalRecordRequestListItem } from "./MedicalRecordRequestListItem";

interface MedicalRecordRequestsListProps {
  items: MedicalRecordRequest[];
  getDetailPath?: (id: string) => string;
}

export function MedicalRecordRequestsList({
  items,
  getDetailPath,
}: MedicalRecordRequestsListProps) {
  const sortedItems = [...items].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return (
    <ul className="divide-y divide-cream-200">
      {sortedItems.map((item) => (
        <MedicalRecordRequestListItem
          key={item.id}
          item={item}
          detailPath={getDetailPath ? getDetailPath(item.id) : `/medical-records/requests/${item.id}`}
        />
      ))}
    </ul>
  );
}

export default MedicalRecordRequestsList;
